import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	recaptchaErrorFlagTitle: {
		id: 'business-form.form-submission.fill-in-view.recaptcha-error-flag-title',
		defaultMessage: 'reCAPTCHA token attempt failed',
		description: 'Error title for reCAPTCHA attempt failure',
	},
	recaptchaErrorFlagContent: {
		id: 'business-form.form-submission.fill-in-view.recaptcha-error-flag-content',
		defaultMessage: 'Please refresh page and try again',
		description: 'Error message for reCAPTCHA verification failure',
	},
	recaptchaCheckboxErrorFlagTitle: {
		id: 'business-form.form-submission.fill-in-view.recaptcha-checkbox-error-flag-title',
		defaultMessage: 'reCAPTCHA checkbox failed to load',
		description: 'Error title for reCAPTCHA checkbox loading failure',
	},
	recaptchaCheckboxErrorFlagContent: {
		id: 'business-form.form-submission.fill-in-view.recaptcha-checkbox-error-flag-content',
		defaultMessage: 'Please refresh page and try again',
		description: 'Error message for reCAPTCHA checkbox loading failure',
	},
	checkboxRecaptchaSectionMessage: {
		id: 'business-form.form-submission.fill-in-view.checkbox-recaptcha.section-message',
		defaultMessage:
			"We'd like to make sure it's really you submitting this. Confirm you're not a robot.",
		description: 'Section message for the checkbox recaptcha',
	},
	checkboxRecaptchaHasVerificationErrorMessage: {
		id: 'business-form.form-submission.fill-in-view.checkbox-recaptcha.section-message-not-verified-error',
		defaultMessage: "Confirm you're not a robot.",
		description: 'Error message for the checkbox recaptcha when not verified',
	},
});
